<template>
  <div>
    <div
      v-if="hasMetaproperties"
      class="metaproperties-table"
    >
      <b-table
        :items="metapropertiesItems"
        stacked="sm"
        borderless
      />
    </div>
  </div>
</template>

<script>
export default {
    name: "MetapropertiesTable",
    props: {
        metaproperties: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        hasMetaproperties() {
            return this.metaproperties && Object.keys(this.metaproperties).length > 0;
        },
        metapropertiesItems() {
            if (!this.metaproperties) {
                return [];
            }

            return Object.entries(this.metaproperties)
                .map(([key, value]) => ({
                    prop: key,
                    value: this.formatPropertyValue(value)
                }));
        }
    },
    methods: {
        formatPropertyValue(value) {
            if (Array.isArray(value)) {
                return value.join(', ');
            }
            return value;
        }
    }
}
</script>
